// extracted by mini-css-extract-plugin
export var dataCell = "_nm-2";
export var dataRow = "_nm-0";
export var headerRow = "_nm-1";